import { plaintextValidator } from '../fields';

const config = { mandatory: true };

export default {
  apiAccessURL: plaintextValidator(config),
  apiKey: plaintextValidator(config)
};
